
// https://stackoverflow.com/questions/18814221/adding-timestamps-to-all-console-messages#:~:text=at%2010%3A33-,leszek.hanusz,-4%2C7242
// Goat

// Dismiss Notices banners
require("./notice");

const { log } = console;

const customLogger = function () {
  const first_parameter = arguments[0];
  const other_parameters = Array.prototype.slice.call(arguments, 1);

  function formatConsoleDate(date) {
    const hour = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const milliseconds = date.getMilliseconds();

    return `[${hour < 10 ? `0${hour}` : hour}:${
      minutes < 10 ? `0${minutes}` : minutes
    }:${seconds < 10 ? `0${seconds}` : seconds}.${`00${milliseconds}`.slice(
      -3
    )}] `;
  }

  log.apply(
    console,
    [formatConsoleDate(new Date()) + first_parameter].concat(other_parameters)
  );
};

// console.log = customLogger;

const mistake = console.error;

const customErrorLogger = function () {
  const first_parameter = arguments[0];
  const other_parameters = Array.prototype.slice.call(arguments, 1);

  function formatConsoleDate(date) {
    const hour = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const milliseconds = date.getMilliseconds();

    return `[${hour < 10 ? `0${hour}` : hour}:${
      minutes < 10 ? `0${minutes}` : minutes
    }:${seconds < 10 ? `0${seconds}` : seconds}.${`00${milliseconds}`.slice(
      -3
    )}] ERROR - `;
  }

  mistake.apply(
    console,
    [formatConsoleDate(new Date()) + first_parameter].concat(other_parameters)
  );
};
// console.error = customErrorLogger;
